export default [
  {
    name: 'Квартира',
    genitiveName: 'Квартиры',
    key: 'flat',
  },
  {
    name: 'Квартира в новостройке',
    genitiveName: 'Квартиры в новостройке',
    key: 'newBuildingFlat',
  },
  {
    name: 'Комната',
    genitiveName: 'Комнаты',
    key: 'room',
  },
  {
    name: 'Доля в квартире',
    genitiveName: 'Доли в квартире',
    key: 'flatShare',
  },
  {
    name: 'Дом/Дача',
    genitiveName: 'Дома/Дачи',
    key: 'house',
  },
  {
    name: 'Коттедж',
    genitiveName: 'Коттеджа',
    key: 'cottage',
  },
  {
    name: 'Таунхаус',
    genitiveName: 'Таунхауса',
    key: 'townhouse',
  },
  {
    name: 'Часть дома',
    genitiveName: 'Части дома',
    key: 'houseShare',
  },
  {
    name: 'Участок',
    genitiveName: 'Участка',
    key: 'land',
  },
];
